import { Box, Grid, Typography } from '@mui/material'
import { format } from 'date-fns'

import { Article } from '@ecm/data/Article'
import Anchor from '@ecm/ui/element/Anchor'
import Color from '@ecm/ui/element/Color'
import MainContainer from '@ecm/ui/element/MainContainer'

type BlogArticlesProps = {
  articles: Article[]
}

const BlogArticles = ({ articles }: BlogArticlesProps) => (
  <Box
    sx={{
      /* eslint-disable sort-keys */
      background: {
        xs: Color.smoke.lightest,
        md: `linear-gradient(to top, transparent 50%, ${Color.smoke.lightest} 0)`,
      },
      paddingBottom: '5em',
      /* eslint-disable sort-keys */
    }}
  >
    <MainContainer sx={{ paddingBottom: '3em' }}>
      <Typography variant="h3" component="h2" margin="0 0 1.5em">
        From Earth Class Mail
      </Typography>
      <Grid container spacing={3}>
        {articles.map(article => (
          <Grid key={article.id} item md={4}>
            <Grid
              container
              direction="column"
              padding="2.5em 1.5em 1em"
              height="100%"
              justifyContent="space-between"
              bgcolor={Color.white.normal}
              sx={{ borderRadius: '8px', boxShadow: '0px 10px 20px rgba(23, 41, 115, 0.06)' }}
            >
              <Grid container spacing={1}>
                <Grid item>
                  <Box
                    padding="0.15px 0.5em"
                    bgcolor={Color.smoke.lighter}
                    sx={{ borderRadius: '4px' }}
                  >
                    <Typography
                      variant="overline"
                      color={Color.saint.darker}
                      fontSize="11px"
                      letterSpacing="0.1em"
                    >
                      {article.categories[0].name}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item>
                  <Typography variant="overline" fontSize="11px" letterSpacing="0.1em">
                    {format(new Date(article.publishedDate), 'MMMM d, yyyy')}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Anchor href={`/blog/${article.slug}`}>
                    <Typography variant="h5" component="h3" margin="1.25em 0 0.5em">
                      {article.title}
                    </Typography>
                  </Anchor>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="p3">
                    {article.contentPreview.replace(/.\s*$/, '')}...
                  </Typography>
                </Grid>
              </Grid>

              <Typography
                variant="overline"
                component="h6"
                margin="1.5em 0 0"
                color={Color.mono.normal}
                fontSize="11px"
                letterSpacing="0.1em"
              >
                By {article.author.fullname}
              </Typography>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </MainContainer>
  </Box>
)

export default BlogArticles
